import React, { useEffect, useState } from 'react'
import { adminGetFileListApi } from '../../../api/file'
import { swalErrorAlert } from '../../../utils/swal/swal'
import { FaFileDownload } from 'react-icons/fa'
import TablePagination from '../../common/TablePagination'

const AdminFileManage = ({ userId, fileType }) => {

    /* file List */
    const [fileList, setFileList] = useState([]) // 업로드된 파일 리스트

    /* useEffect */
    useEffect(() => {
        if (userId && fileType) {
            getFileList(userId, fileType)
        }
        else {
            setFileList([])
        }
    }, [userId, fileType])

    /* Methods */
    const getFileList = async (userId, fileType) => {
        try {
            const response = await adminGetFileListApi(userId, fileType)
            const fileListData = response?.data?.resData ? response?.data?.resData : []
            setFileList(fileListData)
            return

        } catch (error) {
            console.error('파일리스트 조회 실패:', error);
            swalErrorAlert('파일리스트 조회 실패', '파일리스트 조회 중 오류가 발생했습니다.')
            return
        }
    }

    /* Pagination */
    const itemsPerPage = 10
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = fileList.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(fileList.length / itemsPerPage);
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % fileList.length;
        setItemOffset(newOffset);
    };

    return (
        <div>
            <table className="table table-bordered dataTable" cellSpacing="{0}">
                <colgroup>
                    <col width={"80px"} />
                    <col width={"auto"} />
                    <col width={"200px"} />
                </colgroup>
                <thead>
                    <tr className='table-secondary'>
                        <th>번호</th>
                        <th>제목</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody style={{ maxHeight: "calc(100vh - 450px)", overflowX: "auto" }}>
                    {currentItems.map((item, idx) => {
                        let no = fileList.length - itemOffset - idx;
                        return (
                            <tr key={'fileitem-' + item.file_id}>
                                <td>{no}</td>
                                <td>{item.original_name}</td>
                                <td className='text-center'><a href={item.file_url} download><FaFileDownload size={"16px"} /> 다운로드</a></td>
                            </tr>
                        )
                    })}

                    {fileList.length === 0 && (
                        <tr>
                            <td colSpan={5}>
                                <p className='py-3 text-center'>저장된 파일이 없습니다.</p>
                            </td>
                        </tr>
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={4}>
                            <div className='text-center'>
                                <TablePagination handlePageClick={handlePageClick} pageCount={pageCount} />
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>


        </div>
    )
}

export default AdminFileManage